
import { Vue, Component } from 'vue-property-decorator'
import { Alert } from 'ant-design-vue'
import { resolve } from 'dns'

@Component({
  name: 'MonthlyExamModal',
  components: {
    'a-alert': Alert,
  },
})
export default class MonthlyExamModal extends Vue {
  private visible = false
  private examId = ''
  public init(data) {
    this.examId = data.examId
    this.visible = data.visible
  }

  public checkAndCreateMonthExam() {
    return new Promise((resolve) => {
      this.$examHttp
        .get('/api/ksexamination/checkandcreatemonthexam')
        .then((res) => {
          const visible = !res.data || res.data === '' ? false : true
          resolve({ visible })
        })
        .catch(() => {
          resolve({ visible: false })
        })
    })
  }

  private enterExam() {
    window.open(`/examination-management/start-exam?id=${this.examId}&fromType=月度考试`, '_blank')
  }
}
